<template>
    <div class="signup-form__container">
        <div v-if="formState == 'sending'">
            <div class="overlay"></div>
            <div class="form-sending"></div>
        </div>
        <div class="signup-form">
            <div v-if="formState=='sent'" class="row">
                <div class="col-md-12">
                    <p>Olemme lähettäneet ohjeet rekisteröitymisen vahvistamisesta sähköpostiisi.</p>
                    <a href="/fi/login">Siirry kirjautumiseen</a>
                </div>
            </div>
            <form v-if="formVisible" v-on:submit.prevent="sendSignup" method="post" name="send-quote" class="default">
                <div class="row justify-content-center">
                    <div class="col-md-8 text-center">
                        <p>
                            Rekisteröityminen on tarkoitettu esiintyjille,
                            jotka haluavat lisätä oman bändinsä, kuoronsa, dj-palvelunsa, duonsa, jne.
                            buukkaa-bandi.fi -palveluun. Rekisteröityminen ei ole tarpeen,
                            mikäli haluat buukata bändin tai pyytää tarjousta esiitymisestä tilaisuudessasi
                        </p>
                        <div class="signup-form__basic-info">
                            <invitation-notification
                                v-if="showInvitation"
                                :invitation-id=invitationId
                                :invitation-checksum=invitationChecksum
                                @set-email="emailFromInvitation"
                                @set-invitation="setInvitation"
                                @error-occured="invitationError"
                            ></invitation-notification>
                            <div class="form-group" :class="{ 'form-group--error': $v.firstname.$error }">
                                <label>Etunimesi</label>
                                <input type="text" placeholder="Etunimesi" v-model.trim="$v.firstname.$model"/>
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.lastname.$error }">
                                <label>Sukunimesi</label>
                                <input type="text" placeholder="Sukunimesi" v-model.trim="$v.lastname.$model"/>
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.phone.$error }">
                                <label>Puhelinnumerosi</label>
                                <input type="text" placeholder="Puhelinnumerosi" v-model="$v.phone.$model"/>
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.email.$error }">
                                <label>Sähköpostiosoitteesi</label>
                                <input
                                    v-bind:disabled="emailEditDisabled() == true"
                                    type="text"
                                    placeholder="Sähköpostiosoitteesi"
                                    v-model.lazy="$v.email.$model"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 align-items-center text-center">
                        <signup-tos v-model="tosAccepted"></signup-tos>
                        <button v-if="!formDisabled" type="submit" class="btn btn--call-to-action">
                            Rekisteröidy
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import required from 'vuelidate/lib/validators/required';
    import email from 'vuelidate/lib/validators/email';
    import SignupTos from './SignupTos';
    import Routes from '../modules/Routes';
    import FormData from '../modules/FormData';
    import Messages from '../modules/Messages';
    import { isPhoneNumber } from '../modules/Validators';
    import InvitationNotification from './InvitationNotification';

    export default {
        components: {
            InvitationNotification,
            SignupTos
        },
        props: {
            invitationId: {
                type: String,
                default: null
            },
            invitationChecksum: {
                type: String,
                default: null
            },
            token: {
                type: String
            }
        },
        data() {
            return {
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                formState: 'not-sent',
                tosAccepted: false,
                invitationEmail: null,
                invitation: null,
                formVisible: true,
                formDisabled: false
            };
        },
        validations: {
            firstname: {
                required
            },
            lastname: {
                required
            },
            phone: {
                required,
                isPhoneNumber
            },
            email: {
                required,
                email
            }
        },
        methods: {
            showInvitation() {
                return this.invitationId && this.invitationChecksum;
            },
            emailEditDisabled() {
                return Boolean(this.invitation);
            },
            getUrl() {
                return Routes.generate('_public_api_send_signup');
            },
            sendSignup() {
                this.$v.$touch();

                if (!this.tosAccepted) {
                    Messages.error('Sinun täytyy hyväksyä palvelun käyttöehdot');
                    this.$ga.event('Signup', 'TOS not accepted');
                    return;
                }
                if (this.$v.$invalid) {
                    Messages.error('Tarkista, että käytit kaikki tiedot oikeassa muodossa');
                    this.$ga.event('Signup', 'Validation failed');
                    return;
                }
                this.formState = 'sending';
                let formData = new FormData(this.$data, this.token);

                this.$http.post(this.getUrl(), JSON.stringify(formData.parseSignupData(this)), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    Messages.successFromResponse(response);
                    this.formState = 'sent';
                    this.hideForm();
                    this.$ga.event('Signup', 'Sent successfully');
                    gtag('event', 'sign_up');

                    if (response.body.data.redirectUrl) {
                        window.location = response.body.data.redirectUrl;
                    }
                }, (response) => {
                    Messages.errorFromResponse(response);
                    this.formState = 'error';
                    this.$ga.event('Signup', 'Sending failed');
                });
            },
            showForm() {
                this.formVisible = true;
            },
            disableForm() {
                this.formDisabled = true;
            },
            clearInvitation() {
                this.invitation = null;
                this.invitationEmail = null;
            },
            invitationError(response) {
                Messages.errorFromResponse(response);
                this.clearInvitation();
                this.formState = 'error';
            },
            hideForm() {
                this.formVisible = false;
            },
            emailFromInvitation(emailFromInvitation) {
                this.email = emailFromInvitation;
            },
            setInvitation(invitationFromInvitation) {
                this.invitation = invitationFromInvitation;
            }
        }
    };
</script>
